import { useEditorContext } from "../EditorContext";
import AttachmentThumbnails from "../../Attachments";

export default function AttachmentsPlugin() {
	const { attachments, removeAttachment, retryAttachment, commentEdit } = useEditorContext();

	if (!attachments || attachments.length === 0 || commentEdit) return null;

	return (
		<div className="p-2 pt-4">
			<AttachmentThumbnails
				attachments={attachments}
				removeAttachment={removeAttachment}
				retryAttachment={retryAttachment}
			/>
		</div>
	);
}
